import { render, staticRenderFns } from "./mailings-table.vue?vue&type=template&id=3096df5f&"
import script from "./mailings-table.vue?vue&type=script&lang=js&"
export * from "./mailings-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports